import useSelect from './useSelect';
import { get } from 'lodash';

const useGetFullAddress = (value, prefix) => {
  const region = useSelect('region.selected', { id: get(value, `${prefix || ''}region_id`), prefix  })
    const province = useSelect('province.selected', { id: get(value, `${prefix || ''}province_id`), prefix  })
    const municipality = useSelect('municipality.selected', { id: get(value, `${prefix || ''}municipality_id`), prefix  })
    const barangay = useSelect('barangay.selected', { id: get(value, `${prefix || ''}barangay_id`), prefix  })
    return  `${get(region, 'attributes.name') || ''} 
    ${get(province, 'attributes.name') || ''} 
    ${get(municipality, 'attributes.name') || ''} 
    ${get(barangay, 'attributes.name') || ''}
    ${get(value, `${prefix || ''}street`) || ''}`
}

export default useGetFullAddress